import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { IFundingOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { FundingOrgsGridComponent } from './funding-orgs-grid.component';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

interface FundingOrgsContainerComponentProps {
    fundingOrgs?: IFundingOrganization[];
    handleRemoveRow?: (fundingOrganization: IFundingOrganization) => void;
    handleFunderChange?: (fundingOrganizations: IFundingOrganization[]) => void;
    canEdit?: boolean;
    isListingRequest?: boolean;
}

export const FundingOrgsContainerComponent = ({
    fundingOrgs,
    handleRemoveRow,
    handleFunderChange,
    canEdit,
    isListingRequest,
}: FundingOrgsContainerComponentProps) => {
    //TODO PERMFE - redo with permissions+
    const { hasPermission } = useActiveUserContext();

    if (!fundingOrgs) {
        return <LoadIndicatorCenteredView />;
    }

    return (
        <div>
            <FundingOrgsGridComponent
                fundingOrgs={fundingOrgs}
                handleRemoveRow={handleRemoveRow}
                handleFunderChange={handleFunderChange}
                emptyMessage={'No funding organizations found'}
                hideFloatingFilter={true}
                hideHeader={true}
                autoHeight={true}
                canEdit={canEdit || hasPermission(PermissionsEnum.CreateOrg)}
                isListingRequest={isListingRequest}
            />
        </div>
    );
};
